import { default as moment } from 'moment';

export function currentDateWithDaysOffset(daysOffset: number): string {
  const date = new Date();
  date.setDate(date.getDate() + daysOffset);
  return date.toISOString();
}

export function currentDateHour(hour: number): string {
  const date = new Date();
  date.setHours(hour);
  return date.toISOString();
}

// converts any moment date + string time to moment utc
export function convertLocalDateTimeToUTC(
  date: moment.Moment,
  time: string
): moment.Moment {
  const hour = parseInt(time.split(':')[0], 10);
  const min = parseInt(time.split(':')[1], 10);
  // clone to not mutate original date
  // the date param comes always with isUTC = true
  // simple clone will create the same moment
  // using toISOString we make a copy with isUTC = false
  const _dateClone = moment(date.toISOString());

  _dateClone.set({
    hour: hour,
    minute: min
  });

  return _dateClone.utc();
}


/**
 * Calculates the difference between the current time and a provided date.
 * @param dateStr UTC Date in ISO format (e.g., 2024-03-22T...)
 * @param unit The unit of time to return: 'days', 'hours', 'minutes', etc.
 * @returns The difference as a whole number
 */
export function getTimeDiff(dateStr: string, unit: moment.unitOfTime.Diff): number {
  const start = moment.utc(dateStr);
  const now = moment();

  // .diff() automatically handles the calculation based on the provided unit
  return now.diff(start, unit);
}
